// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#app[data-v-a0cc94c6] {\n  width: 100%;\n  height: 100%;\n}\n[dir] #app[data-v-a0cc94c6] {\n  margin: 20px;\n}\n@media (max-width: 768px) {\n[dir] #app[data-v-a0cc94c6] {\n    margin: 10px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
